import axios from 'axios';

const API = axios.create({ baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api' });

API.interceptors.request.use(config => {
  const token = localStorage.getItem('avartana_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

API.interceptors.response.use(
  res => res,
  err => {
    const isLoginEndpoint = err.config?.url?.includes('/auth/login');
    if (err.response?.status === 401 && !isLoginEndpoint) {
      localStorage.removeItem('avartana_token');
      localStorage.removeItem('avartana_user');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export const authAPI = {
  login: (data) => API.post('/auth/login', data),
  register: (data) => API.post('/auth/register', data),
  me: () => API.get('/auth/me'),
  changePassword: (data) => API.put('/auth/change-password', data),
};

export const usersAPI = {
  getAll: (params) => API.get('/users', { params }),
  getById: (id) => API.get(`/users/${id}`),
  update: (id, data) => API.put(`/users/${id}`, data),
  toggleStatus: (id) => API.patch(`/users/${id}/toggle-status`),
  updateLicenseStatus: (id, data) => API.put(`/users/${id}/license-status`, data),
  getDoctors: () => API.get('/users/doctors'),
  getDoctorPatients: (id) => API.get(`/users/doctor-patients/${id || ''}`),
  getUnassignedPatients: () => API.get('/users/unassigned-patients'),
  assignDoctor: (data) => API.post('/users/assign-doctor', data),
  assignPatient: (patientId) => API.post('/users/assign-doctor', { patientId }),
};

export const appointmentsAPI = {
  getAll: (params) => API.get('/appointments', { params }),
  getUpcoming: () => API.get('/appointments/upcoming'),
  create: (data) => API.post('/appointments', data),
  update: (id, data) => API.put(`/appointments/${id}`, data),
  cancel: (id, reason) => API.patch(`/appointments/${id}/cancel`, { reason }),
};

export const therapiesAPI = {
  getAll: () => API.get('/therapies'),
  create: (data) => API.post('/therapies', data),
  update: (id, data) => API.put(`/therapies/${id}`, data),
};

export const prescriptionsAPI = {
  getAll: (params) => API.get('/prescriptions', { params }),
  create: (data) => API.post('/prescriptions', data),
  update: (id, data) => API.put(`/prescriptions/${id}`, data),
};

export const attendanceAPI = {
  getAll: (params) => API.get('/attendance', { params }),
  mark: (data) => API.post('/attendance', data),
};

export const bedsAPI = {
  getAll: (params) => API.get('/beds', { params }),
  create: (data) => API.post('/beds', data),
  update: (id, data) => API.put(`/beds/${id}`, data),
};

export const notificationsAPI = {
  getAll: () => API.get('/notifications'),
  markRead: (id) => API.patch(`/notifications/${id}/read`),
};

export const analyticsAPI = {
  get: () => API.get('/analytics'),
  getCenters: () => API.get('/analytics/centers'),
  createCenter: (data) => API.post('/analytics/centers', data),
};

export const aiAPI = {
  recommend: (data) => API.post('/ai/recommend', data),
  chat: (data) => API.post('/ai/chat', data),
};

export default API;
